import { Routes } from '@angular/router';
import { authGuard, noAuthGuard, wordpressRedirectGuard } from './modules/client/auth/guards/auth.guard';
import { tokenFromUrlGuard } from './modules/client/auth/guards/token-from-url.guard';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [noAuthGuard],
    loadComponent: () => import('./modules/client/auth/pages/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'register',
    canActivate: [noAuthGuard],
    loadComponent: () => import('./modules/client/auth/pages/register/register.component').then(m => m.RegisterComponent)
  },
  {
    path: 'forgot-password',
    canActivate: [noAuthGuard],
    loadComponent: () => import('./modules/client/auth/pages/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent)
  },
  {
    path: 'panel',
    canActivate: [tokenFromUrlGuard, authGuard],
    loadComponent: () => import('./modules/client/panel/layout/panel-layout/panel-layout.component').then(m => m.PanelLayoutComponent),
    children: [
      { path: 'profile', loadComponent: () => import('./modules/client/panel/pages/profile/profile.component').then(m => m.ProfileComponent) },
      { path: 'subscription', loadComponent: () => import('./modules/client/panel/pages/subscription/subscription.component').then(m => m.SubscriptionComponent) },
      { path: 'interests', loadComponent: () => import('./modules/client/panel/pages/interests/interests.component').then(m => m.InterestsComponent) },
      { path: 'history', loadComponent: () => import('./modules/client/panel/pages/history/history.component').then(m => m.HistoryComponent) },
      { path: 'notifications', loadComponent: () => import('./modules/client/panel/pages/notifications/notifications.component').then(m => m.NotificationsComponent) },
      { path: '', redirectTo: 'subscription', pathMatch: 'full' }
    ]
  },
  {
    path: 'planes',
    // Accesible tanto para usuarios autenticados como no autenticados.
    // Se renderiza dentro de un iframe desde WordPress (embed=1).
    loadComponent: () => import('./modules/client/pages/planes/planes.component').then(m => m.PlanesComponent)
  },
  {
    path: 'home',
    canActivate: [noAuthGuard],
    loadComponent: () => import('./modules/client/pages/home/home').then(m => m.HomeComponent)
  },
  {
    path: 'admin',
    loadChildren: () => import('./modules/admin/admin.routes').then(m => m.adminRoutes),
  },
  {
    path: 'client',
    loadChildren: () => import('./modules/client/client.routes').then(m => m.clientRoutes),
  },
  {
    // Called by WordPress (and by the Angular panel) when the user logs out.
    // Shows a "Cerrando sesión..." spinner while clearing the session.
    path: 'logout',
    loadComponent: () => import('./modules/client/auth/pages/logout/logout.component').then(m => m.LogoutComponent),
  },
  {
    // OAuth popup for Google/Facebook login when the app is embedded in an iframe.
    // Google and Facebook reject OAuth flows inside iframes (HTTP 403); this route
    // runs in a popup window opened by the iframe so the full browser context is
    // available. No auth guards — this page must be reachable without a session.
    path: 'oauth-popup',
    loadComponent: () => import('./modules/client/auth/pages/oauth-popup/oauth-popup.component').then(m => m.OAuthPopupComponent),
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: '**',
    canActivate: [wordpressRedirectGuard],
    loadComponent: () => import('./modules/client/pages/home/home').then(m => m.HomeComponent),
  }
];


